/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";

export default function ModalRemoveInterrogation({ setShowModalRemove, handleSubmit }) {
  const handleModal = () => {
    setShowModalRemove(false);
  };

  return (
    <div className="modal modal-remove override-row popup show">
      <div className="modalContent confirm">
        <p>
          <b>This interrogation is billable</b>
        </p>

        <p>
          If removed, it will no longer be eligible for reimbursement. Are you sure you want to remove it?
        </p>
        <div className="content-buttons-Sign_Next">
          <button
            type="button"
            id="btn-anticoagulant-review"
            className="btn btn-sm btn-hide-section"
            onClick={handleModal}
          >
            Cancel
          </button>
          <button
            type="button"
            id="btn-anticoagulant-confirm"
            className="btn btn-sm btnSuccess"
            onClick={handleSubmit}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
